<template>
<div class="px-3">

  <div v-if="loading" class="text-center py-2"><i class="fas fa-spinner fa-spin"></i></div>

  <div v-else-if="products.length == 0" class="text-center py-3">No products</div>

<div v-else>

  <div class="text-center py-3">{{totalProducts}} {{ totalProducts === 1 ? 'product' : 'products' }}</div>

    <table class="table d-none d-md-table">
      <thead class="thead-dark">
                <tr>
                  <th class="first-left text-center" width="10%">Image</th>
                  <th class="pl-3" width="35%">Name</th>
                  <th class="pl-3" width="10%">Status</th>
                  <th class="pl-3" width="10%">Price</th>
                  <th class="pl-3" width="10%">Stock</th>
                  <th class="pl-3" width="10%">Views</th>
                  <th class="first-right pl-3" width="15%">Action</th>
                </tr>
              </thead>
      <tbody>
        <tr v-for="(product, index) in products" :key="index">
            <td class="text-center">
              <img v-if="product.images.length > 0" :src="product.images[0].url" class="product_image" />
              <img v-else class="product_image" src="/images/image-not-found.svg" />
            </td>
            <td class="pl-3">
                <div><b>{{product.name}}</b></div>
                <div><small><a href="#/" class="blue2" @click="showModalChangeCategory(product)">{{product.sub_category.name}}</a></small></div>
            </td>
            <td class="pl-3 pr-0">
                <span :class="setClass(product.status)">{{product.status}}</span>
            </td>
            <td class="pl-3"><div>R {{product.price}}</div></td>
            <td class="pl-3"><div>{{product.stock}}</div></td>
            <td class="pl-3"><div>{{product.views}}</div></td>

            <td class="pl-3 pr-0">
                <a :href="productLink(product)" title="View" class="mr-3"><i class="fas fa-eye"></i></a>
                <a :href="`/products/${product.id}/edit`" title="Edit"><i class="fas fa-edit"></i></a>
                <a href="#/" v-if="product.status == 'Approved' || product.status == 'Inactive'"  @click="showModalChangeStatus(product)" title="Update status" class="ml-3"><i class="fas fa-toggle-on"></i></a>
                <a href="#/" @click="showModalDeleteProduct(product)" title="Delete" class="ml-3"><i class="fa-solid fa-trash"></i></a>
            </td>
        </tr>
      </tbody>
    </table>

    <!-- Mobile -->
        <table class="table d-md-none">
          <tbody>
            <tr v-for="(product, index) in products" :key="index">
  
        <td class="text-center">
            <div class="text-center">
              <img v-if="product.images.length > 0" :src="product.images[0].url" class="product_image" />
              <img v-else class="product_image" src="/images/image-not-found.svg" />
            </div>
            <div class="mt-2">
              <div><b>{{product.name}}</b></div>
              <div><small><a href="#/" class="blue2" @click="showModalChangeCategory(product)">{{product.sub_category.name}}</a></small></div>
              </div>
            <div>R {{product.price}}</div>
            <div>Stock: {{product.stock}}</div>
            <div>Views: {{product.views}}</div>
            <div>
              <a :href="productLink(product)" title="View" class="mr-3"><i class="fas fa-eye"></i></a>
              <a :href="`/products/${product.id}/edit`" title="Edit"><i class="fas fa-edit"></i></a>
              <a href="#/" v-if="product.status == 'Approved' || product.status == 'Inactive'"  @click="showModalChangeStatus(product)" title="Update status" class="ml-3"><i class="fas fa-toggle-on"></i></a>
              <a href="#/" @click="showModalDeleteProduct(product)" title="Delete" class="ml-3"><i class="fa-solid fa-trash"></i></a>
            </div>
        </td>

            </tr>
          </tbody>
        </table>

</div>

<change-status :product="selectedProduct" :page="page"></change-status>
<delete-product :product="selectedProduct" @product-deleted="getProducts()" ref="DeleteProduct" :page="page"></delete-product>
<change-category :product="selectedProduct" :page="page"></change-category>
</div>
</template> 

<script>
import { EventBus } from '../bus';

export default {
  props: ['status','page'],

  data() {
    return {
      products: [],
      tabIndex: 0,
      totalProducts: 0,
      loading: false,
      selectedProduct: {},
    };
  },

  created() {
    this.getProducts();

    EventBus.$on('status-updated', (product) => {
      this.getProducts();
    });
  },

  methods: {

     showModalDeleteProduct(product) {
      this.selectedProduct = product;
      this.$refs.DeleteProduct.clearContent();
      this.$bvModal.show('bv-modal-delete-product-'+this.page);
    },

    showModalChangeCategory(product) {
      this.selectedProduct = product;
      this.$bvModal.show('bv-modal-change-category-'+this.page);
    },

    showModalChangeStatus(product) {
      this.selectedProduct = product;
      this.$bvModal.show(`bv-modal-change-status-${this.page}`);
    },

    getProducts() {

      this.loading = true;

      axios.post('/products/list', {status: this.status}).
      then((response) => {
        this.products = response.data.products;
        this.totalProducts = response.data.total;
        this.loading = false;
      });
    },

    productLink(product) {
      return '/product/'+product.id+'/'+this.createSlug(product.name);
    },

  },
};
</script>

<style scoped>
.product_image { height:3rem; }
</style>